﻿import ajaxPartials from 'Furillo/modules/ajax-partials.js';
import { extend, formattedNumber, getParent } from 'Furillo/modules/helpers.js';
// Full https://www.chartjs.org/ library
//import Chart from 'Vendor/chart.js/auto/auto.js';
import { Chart, Decimation, Legend, Filler, Tooltip, BarElement, BarController, CategoryScale, LinearScale } from 'Vendor/chart.js/dist/chart.js';
import ChartDataLabels from 'Vendor/chartjs-plugin-datalabels';

export default class EsemBlockEffectCalculator {

    constructor(element, options) {

        const defaults = {};

        this.element = element;
        this.options = extend(defaults, options);
        this.chart = null;
        this.chartData = [];

        this.init();
    }

    setChartData() {
        const self = this;

        self.chartData = [];
        self.element.querySelectorAll('.category[data-kwh]').forEach(element => {
            var label = element.getAttribute('data-label');
            var color = element.getAttribute('data-color');
            var kwh = JSON.parse(element.getAttribute('data-kwh'));
            
            self.chartData.push({
                label: label,
                backgroundColor: color,
                hoverBorderWidth: 0,
                data: Object.values(kwh)
            });
        });
    }

    updateMainChart() {
        const self = this;

        var effectCalculatorData = {
            baseConsumers: [],
            consumerCategories: []
        };

        let baseConsumption = parseFloat(self.element.querySelector('input[type="radio"]:checked').value.replace(',', '.'));
        if (isNaN(baseConsumption))
            baseConsumption = parseFloat(document.getElementById('base-consumer-custom-value').value.replace(',', '.'));

        effectCalculatorData.baseConsumers.push({ consumption: baseConsumption, isActive: true });

        self.element.querySelectorAll('.category.consumers').forEach(category => {
            var consumerCategory = {
                name: category.getAttribute('data-label'),
                color: category.getAttribute('data-color'),
                consumers: []
            };

            category.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
                var parent = getParent(checkbox, '.bg-white');

                consumerCategory.consumers.push({
                    category: consumerCategory.name,
                    name: checkbox.getAttribute('data-label'),
                    consumption: parseFloat(parent.querySelector('input[type="number"]').value.replace(',', '.')),
                    timeStart: parent.querySelector('input[type="time"].timeStart').value,
                    timeEnd: parent.querySelector('input[type="time"].timeEnd').value,
                    isActive: true
                });                
            });

            effectCalculatorData.consumerCategories.push(consumerCategory);
        });

        fetch('/api/effectcalculator/chartdata', {
            method: 'POST',
            mode: 'same-origin',
            cache: 'no-cache',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(effectCalculatorData)
        }).then((response) => {            
            return response.json();
        }).then((json) => {
            if (!json)
                return;

            self.element.querySelector('.category:not(.consumers)').setAttribute('data-kwh', JSON.stringify(json.baseConsumers[0].consumptions));

            for (var i = 0; i < json.consumerCategories.length; i++) {

                var category = self.element.querySelector('.category.consumers[data-label="' + json.consumerCategories[i].name + '"]');
                if (!category)
                    continue;

                category.setAttribute('data-kwh', JSON.stringify(json.consumerCategories[i].consumptions));

                category.querySelectorAll('label[data-label] span.text-danger').forEach(element => { element.classList.add('d-none'); });

                for (var j = 0; j < json.consumerCategories[i].consumers.length; j++) {
                    if (!json.consumerCategories[i].consumers[j].isPeakConsumption)
                        continue;                                           

                    var text = category.querySelector('label[data-label="' + json.consumerCategories[i].consumers[j].name + '"] span.text-danger');
                    if (!text)
                        continue;

                    text.classList.remove('d-none');
                }                
            }

            self.setChartData();
            self.chart.data.datasets = self.chartData;
            self.chart.update();

        }).catch(function (err) {
            console.warn('Something went wrong.', err);
        });


    }

    initMainChart() {
        const self = this;

        if (!self.chartData)
            return;

        const canvas = self.element.querySelector('canvas[id^="chart-"]');

        const labels = [];
        for (var i = 0; i < 24; i++) {
            labels.push(String(i).padStart(2, '0'));
        }

        const data = {
            labels: labels,
            datasets: this.chartData
        };
        
        const config = {
            type: 'bar',
            data: data,
            options: {
                responsive: true,
                aspectRatio: 2,
                maintainAspectRatio: true,
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                        beginAtZero: true,
                        offset: false,
                        ticks: {
                            callback: function (value, index, ticks) {
                                return formattedNumber(value) + ' kW';
                            }
                        }
                    }
                },
                interaction: {
                    intersect: false,
                    mode: 'index',
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: {
                            font: {
                                size: 16
                            },
                            filter: (legendItem, data) => {
                                return data.datasets[legendItem.datasetIndex].data.some(v => v !== 0);
                            }                        
                        }
                    },
                    title: {
                        display: false
                    },
                    tooltip: {
                        usePointStyle: true,
                        callbacks: {
                            title: function (tooltipItems) {
                                const currentTime = tooltipItems[0].parsed.x;
                                let toTime = currentTime + 1;                                
                                if (toTime > 23)
                                    toTime = 0;

                                return 'kl. ' + String(currentTime).padStart(2, '0') + ':00 - ' + String(toTime).padStart(2, '0') + ':00';
                            },
                            afterTitle: function (tooltipItems) {                                
                                let sum = 0.0;
                                for (var i = 0; i < tooltipItems.length; i++) {
                                    sum += tooltipItems[i].parsed.y;
                                }
                                return 'Total förbrukning: ' + formattedNumber(sum) + ' kW';
                            },
                            label: function (tooltipItem) {
                                return tooltipItem.dataset.label + ' ' + formattedNumber(tooltipItem.parsed.y) + ' kW';
                            }
                        },
                        filter: function (tooltipItem) {
                            return tooltipItem.parsed.y !== 0;
                        }
                    }
                }
            }
        };

        //options: { plugins: { legend: { labels: { filter: (legendItem, data) => data.datasets[0].data[legendItem.index] != 0 } } } }

        self.chart = new Chart(canvas, config);        
    }

    //getItemIndex(label) {
    //    const self = this;

    //    if (!self.chart)
    //        return -1;

    //    if (!label || label.length === 0)
    //        return -1;

    //    const dataset = self.chart.data.datasets[0];
    //    return dataset.data.findIndex((item) => item.ChartAxisLabel === label);
    //}


    init() {
        const self = this;

        ajaxPartials.makeRequest(self.element, () => {

            self.setChartData();
            self.initMainChart();


            self.element.querySelectorAll('input[type="checkbox"],input[type="radio"]').forEach(element => {
                element.addEventListener('change', event => {                    
                    if (event.target.type === 'radio') {                        
                        if (event.target.id === 'base-consumer-custom') {
                            const input = document.getElementById('base-consumer-custom-value');
                            input.focus();
                            if (input.value.length > 0) {
                                self.updateMainChart();
                            }
                            return;
                        }                        
                    }

                    self.updateMainChart();
                });               
            });

            self.element.querySelectorAll('input[type="number"],input[type="time"]').forEach(element => {
                element.addEventListener('blur', event => {
                    self.updateMainChart();
                });
            });

            document.getElementById('categories-show').addEventListener('click', event => {
                event.preventDefault();

                self.element.querySelector('.categories-wrapper').style = '';

                event.target.remove();
            });
        });
                
        // Only needed when not using 'auto'
        Chart.register(Decimation, Legend, Filler, Tooltip, BarElement, BarController, CategoryScale, LinearScale);        
    }
}